import React from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import BaseLayout from "../../../components/BaseLayout/BaseLayout";
import SelectSearchBootstrap from "../../../components/InputSelectSearch/SelectSearchBootstrap";
import PropertyService from "../../../Services/PropertyService";

import WYSIWYGEditor from "../../../components/InputTextareaEditor/WYSIWYG";

import boldIcon from "../../../assets/icons/toolbar/bold.svg";
import italicIcon from "../../../assets/icons/toolbar/italic.svg";
import underlineIcon from "../../../assets/icons/toolbar/underline.svg";
import alignLeftIcon from "../../../assets/icons/toolbar/align-left.svg";
import alignCenterIcon from "../../../assets/icons/toolbar/align-center.svg";
import alignRightIcon from "../../../assets/icons/toolbar/align-right.svg";
import alignJustifyIcon from "../../../assets/icons/toolbar/align-justify.svg";
import listBulletedIcon from "../../../assets/icons/toolbar/list-bulleted.svg";
import listNumberedIcon from "../../../assets/icons/toolbar/list-numbered.svg";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import {
  StyledToggleButton,
  StyledToggleButtonGroup,
} from "../../../components/CustomStyles/CustomToggleButton";
import { formatCurrency, formatDB } from "../../../components/Utils/Currency";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { useQuery, useMutation } from "react-query";
import RegionService from "../../../Services/RegionService";
import DeliveryService from "../../../Services/DeliveryService";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { css, cx } from "emotion";
import { Loader } from "@googlemaps/js-api-loader";
import markerIcon from "../../../assets/icons/img_marker.png";
import CloseIcon from "@material-ui/icons/Close";
import NewImageUploader from "../../../components/NewImageUploader";
import { handleError } from "../../../components/Utils/Utils";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";
import History from "../../../History/History";

// style
const mapModal = css`
  max-width: 500px;
  margin: 0 auto;

  form {
    position: relative;
    min-height: 92vh;
  }

  .modal-content {
    background-color: #ffffff !important;
    border: none !important;
    min-height: 100vh;
  }

  .modal-body {
    padding: 0;
  }

  .modal-header {
    padding: 0.5rem 1rem;
    height: 54px;
    border: none;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  }

  .modal-footer {
    width: 100%;
    padding: 0.5rem 1rem;
    border: none;
    position: absolute;
    bottom: 0;
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.25);
    background: #ffffff;
  }
`;

const FormPropertyEdit = (props) => {
  const user = JSON.parse(localStorage.getItem("user")) || "";
  const { id } = props.match.params;
  let [optionsPropertyType, setOptionsPropertyType] = React.useState([
    {
      value: "mall",
      name: "Mall",
    },
    {
      value: "hotel",
      name: "Hotel",
    },
    {
      value: "residential",
      name: "Residential",
    },
  ]);
  let [optionsTimeZone, setOptionsTimeZone] = React.useState([
    {
      value: "Asia/Jakarta",
      name: "Asia/Jakarta",
    },
    {
      value: "Asia/Makassar",
      name: "Asia/Makassar",
    },
    {
      value: "Asia/Jayapura",
      name: "Asia/Jayapura",
    },
  ]);
  const [optionsParent, setOptionsParent] = React.useState([]);
  const [feeType, setFeeType] = React.useState(false);
  const [provinces, setProvinces] = React.useState([]);
  const [selectedProvince, setSelectedProvince] = React.useState("");
  const [districts, setDistricts] = React.useState([]);
  const [selectedDistrict, setSelectedDistrict] = React.useState("");
  const [subdistricts, setSubDistricts] = React.useState([]);
  const [selectedSubDistrict, setSelectedSubDistrict] = React.useState("");
  const [previewMap, setPreviewMap] = React.useState("");
  const [map, setMap] = React.useState("");
  const [modal, setModal] = React.useState(false);
  const [searchAddress, setSearchAddress] = React.useState("");
  const [listPlaces, setListPlaces] = React.useState([]);
  const [mapCenterPosition, setMapCenterPosition] = React.useState("");
  const [locationAddress, setLocationAddress] = React.useState("");
  const [deliveryPackages, setDeliveryPackages] = React.useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "property_deliveries",
    }
  );

  const watchFields = watch();
  const refDescription = React.createRef();
  const boxPlacePredictionsRef = React.useRef();
  const toggle = () => setModal(!modal);

  const numberMask = (allowDecimal, prefix, sufix) => {
    return createNumberMask({
      prefix: prefix,
      sufix: sufix,
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ".",
      allowDecimal: allowDecimal,
      decimalSymbol: ",",
    });
  };

  const handleChange = (event) => {
    setValue(event.target.name, event.target.value);
  };

  const handleChangeDelivery = (id, event) => {
    setValue(event.target.name, {
      id: id,
      checked_st: event.target.value,
    });
  };

  const handleChangeFee = (event) => {
    setValue("fee." + event.target.name, event.target.value);
  };

  const handleSelectFeeType = (event, newFeeType) => {
    if (newFeeType !== null) {
      handleChangeFee({ target: { name: "percent", value: "" } });
      handleChangeFee({ target: { name: "amount", value: "" } });
      setFeeType(newFeeType);
    }
  };

  const asyncGetOptionsParent = (query) => {
    return new Promise((resolve, reject) => {
      PropertyService.getList({
        type: "brand",
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsParent(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const getDetailProperty = useQuery(
    ["formProperty-Edit", id],
    () => {
      return PropertyService.getDetail(id).then((res) => res.data);
    },
    {
      enabled: false,
      cacheTime: 0,
      retry: false,
      onSuccess: (data) => {
        data.fee.percent =
          data.fee.percent > 0
            ? formatCurrency(
                process.env.REACT_APP_CURRENCY_CODE,
                data.fee.percent,
                true
              )
            : "";
        data.fee.amount =
          data.fee.amount > 0
            ? formatCurrency(
                process.env.REACT_APP_CURRENCY_CODE,
                data.fee.amount,
                true
              )
            : "";
        resetForm(data);
      },
    }
  );

  const getProvinceName = (code) => {
    if (code !== "" && provinces?.length > 0) {
      const item = provinces?.find((val) => val.value === code);

      if (item) {
        return item.name;
      } else {
        return "";
      }
    }

    return "";
  };

  const getDistrictName = (code) => {
    if (code !== "" && districts?.length > 0) {
      const item = districts?.find((val) => val.value === code);

      if (item) {
        return item.name;
      } else {
        return "";
      }
    }

    return "";
  };

  const getSubdistrictName = (code) => {
    if (code !== "" && subdistricts?.length > 0) {
      const item = subdistricts?.find((val) => val.value === code);

      if (item) {
        return item.name;
      } else {
        return "";
      }
    }

    return "";
  };

  const getDeliveryPackage = useQuery(
    ["getDeliveryPackage", "formPropertyEdit"],
    () => {
      return DeliveryService.getDeliveryPropertyAll(id).then((res) => res.data);
    },
    {
      enabled: false,
      retry: false,
      cacheTime: 0,
      onSuccess: (data) => {
        if (data?.length > 0) {
          for (let i = 0; i < data?.length; i++) {
            if (data[i].delivery_packages?.length > 0) {
              for (let j = 0; j < data[i].delivery_packages?.length; j++) {
                setValue(`property_deliveries.${i + j}`, {
                  id: data[i].delivery_packages[j]?.id,
                  checked_st: data[i].delivery_packages[j]?.checked_st || false,
                });
              }
            }
          }
        }
        setDeliveryPackages(data);
      },
    }
  );

  // MAP
  // Load map
  const loaderMap = new Loader({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    version: "weekly",
    libraries: ["places"],
    gesturehandling: "cooperative",
  });

  function getLocationFromAddress(address) {
    return new Promise((resolve, reject) => {
      return new window.google.maps.Geocoder().geocode(
        { address: address },
        (results, status) => {
          if (status === "OK") {
            resolve(results[0]?.geometry?.location?.toJSON());
          } else {
            reject("");
          }
        }
      );
    });
  }

  function geocodeAddress(address, resultsMap) {
    new window.google.maps.Geocoder().geocode(
      { address: address },
      (results, status) => {
        if (status === "OK") {
          resultsMap.fitBounds(results[0].geometry.bounds);
        }
      }
    );
  }

  function getAddress(latLng) {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      {
        latLng: latLng,
      },
      function (results, status) {
        if (status === "OK") {
          setLocationAddress(results[0].formatted_address);
        } else {
          setLocationAddress("address not found");
        }
      }
    );
  }

  function handleGetDetailPlace(placeId) {
    const placeservice = new window.google.maps.places.PlacesService(map);

    placeservice.getDetails(
      {
        placeId: placeId,
      },
      (result, status) => {
        if (status === "OK") {
          setMapCenter(result.geometry.location);
          const position = result.geometry.location.toJSON();
          setValue("latitude", position?.lat?.toString());
          setValue("longitude", position?.lng?.toString());
          setListPlaces([]);
          boxPlacePredictionsRef.current.classList.add("d-none");
          boxPlacePredictionsRef.current.classList.remove("fade-in-fwd");
        }
      }
    );
  }

  function setMapCenter(location) {
    map.setCenter(location);
    map.setZoom(18);
  }

  function placePredictionCallback(results, status) {
    if (results.length > 0) {
      setListPlaces(results);
      boxPlacePredictionsRef.current.classList.remove("d-none");
      boxPlacePredictionsRef.current.classList.add("fade-in-fwd");
    }
  }

  function autocompleteService(address, resultsMap) {
    const autocompleteservice =
      new window.google.maps.places.AutocompleteService();
    const request = {
      input: address,
    };

    autocompleteservice.getPlacePredictions(request, placePredictionCallback);
  }

  const handleShowMap = () => {
    const address =
      watchFields["subdistrict"] && watchFields["district"]
        ? `${watchFields["name"]}, ${getSubdistrictName(
            watchFields["subdistrict"]["code"]
          )}, ${getDistrictName(watchFields["district"]["code"])}`
        : `Jakarta, Indonesia`;
    loaderMap
      .load()
      .then(() => {
        const newMap = new window.google.maps.Map(
          document.getElementById("map-container"),
          {
            disableDefaultUI: true,
          }
        );

        getLocationFromAddress(address)
          .then((location) => {
            if (!watchFields["latitude"] || !watchFields["longitude"]) {
              setValue(`latitude`, location?.lat?.toString());
              setValue(`longitude`, location?.lng?.toString());
            }

            setMap(newMap);
            setSearchAddress("");
          })
          .catch((error) => {
            console.log("Error get location from address");
          });
      })
      .catch((error) => {
        console.log("Error => ", error);
      });
  };

  const handleShowPreviewMap = (lat, lng) => {
    loaderMap
      .load()
      .then(() => {
        const newMap = new window.google.maps.Map(
          document.getElementById("map-preview-container"),
          {
            zoom: 14,
            center: { lat: parseFloat(lat), lng: parseFloat(lng) },
            disableDefaultUI: true,
          }
        );
        setPreviewMap(newMap);
      })
      .catch((error) => {
        console.log("Error => ", error);
      });
  };

  const handleChangeSearchAddress = (e) => {
    setSearchAddress(e.target.value);
  };

  // END OF MAP

  const getProvince = useQuery(
    "formProperty-GetProvince",
    () => {
      return RegionService.getRegionByParent("ID").then((res) => res.data);
    },
    {
      enabled: false,
      cacheTime: 0,
      retry: false,
      onSuccess: (data) => {
        const remap = data?.map((val) => ({
          value: val?.code,
          name: val?.name,
        }));
        setProvinces(remap);
      },
    }
  );

  const getDistrict = useQuery(
    "formProperty-GetDistrict",
    () => {
      return RegionService.getRegionByParent(selectedProvince).then(
        (res) => res.data
      );
    },
    {
      enabled: false,
      cacheTime: 0,
      retry: false,
      onSuccess: (data) => {
        const remap = data?.map((val) => ({
          value: val?.code,
          name: val?.name,
        }));
        setDistricts(remap);
      },
    }
  );

  const getSubDistrict = useQuery(
    "formProperty-GetSubDistrict",
    () => {
      return RegionService.getRegionByParent(selectedDistrict).then(
        (res) => res.data
      );
    },
    {
      enabled: false,
      cacheTime: 0,
      retry: false,
      onSuccess: (data) => {
        const remap = data?.map((val) => ({
          value: val?.code,
          name: val?.name,
        }));
        setSubDistricts(remap);
      },
    }
  );

  // Mutation
  const mutationMappingDelivery = useMutation(
    DeliveryService.postDeliveryPackageProperty,
    {
      onSuccess: (data, variables) => {
        notifUtils("Success Save Property Delivery Package", "success");

        History.push("/property");
      },
      onError: (error, variables) => {
        handleError(error.toString());
      },
    }
  );

  const mutationUpdateProperty = useMutation(PropertyService.putData, {
    onSuccess: (data, variables) => {
      notifUtils("Success Update Property", "success");

      const temp_filter = watchFields["property_deliveries"]?.filter(
        (val) => val?.checked_st === true
      );
      const delivery_package_ids = temp_filter?.map((val) => val?.id);

      const id = data?.data?.result?.id;

      const params = {
        property_id: id,
        delivery_package_ids: delivery_package_ids || [],
      };

      mutationMappingDelivery.mutate(params);
    },
    onError: (error, variables) => {
      handleError(error.toString());
    },
  });

  const onSubmit = (data) => {
    let { property_deliveries, ...params } = data;

    const fee_percent =
      params.fee.percent !== ""
        ? parseFloat(formatDB(params.fee.percent.replace("%", "")))
        : 0;
    const fee_amount =
      params.fee.amount !== ""
        ? parseFloat(
            formatDB(
              params.fee.amount.replace(
                process.env.REACT_APP_CURRENCY_SYMBOL,
                ""
              )
            )
          )
        : 0;

    params.fee = {
      name: params.fee.name,
      percent: fee_percent,
      amount: fee_amount,
    };

    params.level = 1;

    if (params.type === "brand") {
      params.level = 2;
    }

    mutationUpdateProperty.mutateAsync(params);
  };

  const handleChangeProvince = (e) => {
    setSelectedProvince(e);
    setValue("province.code", e);
    setValue("district.code", "");
    setValue("subdistrict.code", "");
    setDistricts([]);
    setSubDistricts([]);
  };

  React.useEffect(() => {
    if (selectedProvince !== "") {
      getDistrict.refetch();
    }
  }, [selectedProvince]);

  const handleChangeDistrict = (e) => {
    setSelectedDistrict(e);
    setValue("district.code", e);
    setValue("subdistrict.code", "");
    setSubDistricts([]);
  };

  React.useEffect(() => {
    if (selectedDistrict !== "") {
      getSubDistrict.refetch();
    }
  }, [selectedDistrict]);

  const handleChangeSubDistrict = (e) => {
    setSelectedSubDistrict(e);
    setValue("subdistrict.code", e);
  };

  function resetForm(data) {
    reset(data);
    register("latitude", {
      required: "Please set your latitude location",
    });
    register("longitude", {
      required: "Please set your longitude location",
    });

    setFeeType(
      data.fee.percent > 0 ? "percent" : data.fee.amount > 0 ? "amount" : ""
    );

    if (data?.type !== "" && data?.type !== "brand") {
      asyncGetOptionsParent(data?.parent?.name);
    }

    getProvince.refetch();
    setSelectedProvince(data?.province?.code);
    setSelectedDistrict(data?.district?.code);
    getDeliveryPackage.refetch();
  }

  React.useEffect(() => {
    if (user?.operational?.level === 3) {
      let temp = optionsPropertyType;
      temp.push({
        value: "brand",
        name: "Brand",
      });

      setOptionsPropertyType(temp);
    }

    getDetailProperty.refetch();
  }, [id]);

  React.useEffect(() => {
    if (modal) {
      if (watchFields["latitude"] && watchFields["longitude"]) {
        setSearchAddress("");
      }
      handleShowMap();
    }
  }, [modal]);

  React.useEffect(() => {
    if (boxPlacePredictionsRef.current) {
      boxPlacePredictionsRef.current.classList.add("d-none");
      boxPlacePredictionsRef.current.classList.remove("fade-in-fwd");
    }

    // Add delay in search
    const timeout = setTimeout(() => {
      if (map) {
        if (searchAddress !== "") {
          geocodeAddress(searchAddress, map);
          autocompleteService(searchAddress, map);
        } else if (
          searchAddress === "" &&
          watchFields["latitude"] &&
          watchFields["longitude"]
        ) {
          setMapCenter({
            lat: parseFloat(watchFields["latitude"]),
            lng: parseFloat(watchFields["longitude"]),
          });
          let markerElement = document.createElement("div");
          markerElement.className = "center-marker";
          map.getDiv().appendChild(markerElement);
        }
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [map, searchAddress]);

  React.useEffect(() => {
    function updateMapCenter() {
      if (mapCenterPosition !== "") {
        getAddress(mapCenterPosition);
        setValue("latitude", mapCenterPosition?.lat?.toString());
        setValue("longitude", mapCenterPosition?.lng?.toString());
      }
    }

    // Add delay in center changed
    const timeout = setTimeout(() => {
      updateMapCenter();
    }, 500);

    return () => clearTimeout(timeout);
  }, [mapCenterPosition]);

  React.useEffect(() => {
    if (map) {
      map.addListener("center_changed", (event) => {
        const position = map.getCenter().toJSON();
        setMapCenterPosition(position);
      });
    }
  }, [map]);

  React.useEffect(() => {
    if (previewMap) {
      const newMarker = new window.google.maps.Marker({
        position: {
          lat: parseFloat(watchFields["latitude"]),
          lng: parseFloat(watchFields["longitude"]),
        },
        map: previewMap,
        icon: markerIcon,
        title: "",
      });
      // previewMap.addListener("click", (event) => {
      //   toggle();
      // });
    }
  }, [previewMap]);

  React.useEffect(() => {
    if (watchFields["latitude"] && watchFields["longitude"]) {
      handleShowPreviewMap(watchFields["latitude"], watchFields["longitude"]);
    }
  }, [watchFields["latitude"], watchFields["longitude"]]);

  return (
    <BaseLayout background="gray">
      <div className="row">
        <div className="col-12">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-none">
              <li className="breadcrumb-item">
                <a href="/property">List Property</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Edit Property
              </li>
            </ol>
          </nav>
        </div>
        <div className="col-12">
          <div className="card border-0 rounded-8px">
            <div className="card-header bg-white">
              <h3 className="card-title mb-0 font-20">Edit Property</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="category"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Select Property Type</span>
                      </label>
                      <Controller
                        name="type"
                        control={control}
                        render={({ field }) => (
                          <SelectSearchBootstrap
                            {...field}
                            options={optionsPropertyType}
                            search
                            closeOnSelect={true}
                            placeholder="Search for property type"
                          />
                        )}
                        rules={{
                          required: "Please select property type",
                        }}
                        defaultValue={watchFields["type"] || ""}
                      />
                      {errors.type && (
                        <small className="form-text text-error">
                          {errors?.type?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  {user?.operational?.level === 3 &&
                    watchFields["type"] &&
                    watchFields["type"] !== "brand" &&
                    watchFields["type"] !== "" && (
                      <div className="col-md-6 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="category"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Select Brand</span>
                          </label>
                          <Controller
                            name="parent.id"
                            control={control}
                            render={({ field }) => (
                              <SelectSearchBootstrap
                                {...field}
                                options={optionsParent}
                                getOptions={(query) =>
                                  asyncGetOptionsParent(query)
                                }
                                search
                                closeOnSelect={true}
                                placeholder="Search for search parent property"
                              />
                            )}
                            defaultValue={watchFields["parent.id"] || ""}
                          />
                          {errors.parent && errors.parent.id && (
                            <small className="form-text text-error">
                              {errors?.parent?.id?.message}
                            </small>
                          )}
                        </div>
                      </div>
                    )}
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="name"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Property Name</span>
                        <span className="font-bold text-muted">
                          {watchFields["name"]?.length || 0} / 255
                        </span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control rounded-8px"
                        {...register("name", {
                          required: "Please input property name",
                          maxLength: {
                            value: 255,
                            message: "Maximum character 255",
                          },
                        })}
                      />
                      {errors.name && (
                        <small className="form-text text-error">
                          {errors?.name?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="name"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Property Initial</span>
                        <span className="font-bold text-muted">
                          {watchFields["initial"]?.length || 0} / 10
                        </span>
                      </label>
                      <input
                        type="text"
                        id="initial"
                        name="initial"
                        className="form-control rounded-8px"
                        {...register("initial", {
                          required: "Please input property initial",
                          maxLength: {
                            value: 10,
                            message: "Maximum character 10",
                          },
                          pattern: {
                            value: /^[A-Z0-9]*$/,
                            message: "Only allow capital letter and number",
                          },
                        })}
                      />
                      {errors.initial && (
                        <small className="form-text text-error">
                          {errors?.initial?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="about"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Description</span>
                        <span className="font-bold text-muted">
                          {watchFields["about"]?.length || 0} / 2000
                        </span>
                      </label>
                      {!getDetailProperty?.isLoading &&
                        getDetailProperty?.isSuccess && (
                          <Controller
                            id="about"
                            name="about"
                            control={control}
                            rules={{
                              required: "Description is required",
                              maxLength: {
                                value: 2000,
                                message: "Maximum character 2000",
                              },
                            }}
                            render={({ field }) => (
                              <WYSIWYGEditor
                                {...field}
                                ref={refDescription}
                                defaultEditorContent={
                                  watchFields["about"] || ""
                                }
                                toolbar={{
                                  options: [
                                    "blockType",
                                    "inline",
                                    "textAlign",
                                    "list",
                                  ],
                                  blockType: {
                                    inDropdown: true,
                                    options: [
                                      "Normal",
                                      "H1",
                                      "H2",
                                      "H3",
                                      "H4",
                                      "H5",
                                      "H6",
                                    ],
                                  },
                                  inline: {
                                    inDropdown: false,
                                    options: ["bold", "italic", "underline"],
                                    bold: { icon: boldIcon },
                                    italic: { icon: italicIcon },
                                    underline: { icon: underlineIcon },
                                  },
                                  textAlign: {
                                    inDropdown: false,
                                    className: undefined,
                                    component: undefined,
                                    dropdownClassName: undefined,
                                    options: [
                                      "left",
                                      "center",
                                      "right",
                                      "justify",
                                    ],
                                    left: { icon: alignLeftIcon },
                                    center: { icon: alignCenterIcon },
                                    right: { icon: alignRightIcon },
                                    justify: { icon: alignJustifyIcon },
                                  },
                                  list: {
                                    inDropdown: false,
                                    options: ["unordered", "ordered"],
                                    unordered: { icon: listBulletedIcon },
                                    ordered: { icon: listNumberedIcon },
                                  },
                                }}
                              />
                            )}
                          />
                        )}
                      {errors.about && (
                        <small className="form-text text-error">
                          {errors?.about?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  {watchFields["type"] &&
                    watchFields["type"] !== "" &&
                    watchFields["type"] !== "brand" && (
                      <div className="col-4 col-12">
                        <div className="form-group mb-4">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  watchFields["have_runner"] &&
                                  watchFields["have_runner"] === true
                                }
                                onChange={(e) =>
                                  handleChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked,
                                    },
                                  })
                                }
                                name="have_runner"
                                color="primary"
                                control={control}
                              />
                            }
                            label="Have Runner ?"
                          />
                        </div>
                      </div>
                    )}
                </div>
                {watchFields["type"] &&
                  watchFields["type"] !== "" &&
                  watchFields["type"] !== "brand" && (
                    <div className="row">
                      <div className="col-12">
                        <h4 className="font-18">Fee Detail</h4>
                      </div>
                      <div className="col-md-4 col-12">
                        <div className="fotm-group mb-4">
                          <label
                            htmlFor="fee_name"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>
                              Custom Fee Name <small>(optional)</small>
                            </span>
                            <span className="font-bold text-muted">
                              {watchFields["fee"]["name"]?.length || 0} / 50
                            </span>
                          </label>
                          <input
                            type="text"
                            id="fee_name"
                            name="fee.name"
                            className="form-control rounded-8px"
                            {...register("fee.name", {
                              maxLength: {
                                value: 50,
                                message: "Maximum character 50",
                              },
                            })}
                          />
                          {errors?.fee && errors?.fee?.name && (
                            <small className="form-text text-error">
                              {errors?.fee?.name?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="about"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Choose Fee Type</span>
                          </label>
                          <StyledToggleButtonGroup
                            value={feeType}
                            exclusive
                            onChange={handleSelectFeeType}
                            aria-label="Fee Type"
                          >
                            <StyledToggleButton
                              value="percent"
                              aria-label="Percent"
                            >
                              %
                            </StyledToggleButton>
                            <StyledToggleButton
                              value="amount"
                              aria-label="Amount"
                            >
                              Fixed Amount
                            </StyledToggleButton>
                          </StyledToggleButtonGroup>
                        </div>
                      </div>
                      {feeType === "percent" && (
                        <div className="col-md-4 col-12">
                          <div className="fotm-group mb-4">
                            <label
                              htmlFor="fee_percent"
                              className="font-12 font-bold d-flex justify-content-between align-items-center"
                            >
                              <span>Fee Percent</span>
                            </label>
                            <Controller
                              render={({ field }) => (
                                <MaskedInput
                                  {...field}
                                  mask={numberMask(true, "", "%")}
                                  className="form-control rounded-8px"
                                />
                              )}
                              name="fee.percent"
                              control={control}
                              rules={{
                                required: "Please input fee percentage",
                              }}
                              defaultValue={watchFields["fee"]["percent"] || 0}
                            />
                            {errors?.fee?.percent && (
                              <small className="form-text text-error">
                                {errors?.fee?.percent?.message}
                              </small>
                            )}
                          </div>
                        </div>
                      )}
                      {feeType === "amount" && (
                        <div className="col-md-4 col-12">
                          <div className="fotm-group mb-4">
                            <label
                              htmlFor="fee_amount"
                              className="font-12 font-bold d-flex justify-content-between align-items-center"
                            >
                              <span>Fee Amount</span>
                            </label>
                            <Controller
                              render={({ field }) => (
                                <MaskedInput
                                  {...field}
                                  mask={numberMask(false, "", "")}
                                  className="form-control rounded-8px"
                                />
                              )}
                              name="fee.amount"
                              control={control}
                              rules={{
                                required: "Please input fee amount",
                              }}
                              defaultValue={watchFields["fee"]["amount"] || 0}
                            />
                            {errors?.fee?.amount && (
                              <small className="form-text text-error">
                                {errors?.fee?.amount?.message}
                              </small>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                <div className="row">
                  <div className="col-12">
                    <h4 className="font-18">Contact &amp; Address</h4>
                  </div>
                  <div className="col-md-4 col-12 mb-4">
                    <label
                      htmlFor="email"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>E-Mail</span>
                      <span className="font-bold text-muted">
                        {watchFields["email"]?.length || 0} / 100
                      </span>
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      className="form-control rounded-8px"
                      {...register("email", {
                        required: "Please input property email",
                        pattern: {
                          value:
                            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                          message: "Email address format not valid",
                        },
                        maxLength: {
                          value: 100,
                          message: "Maximum character 100",
                        },
                      })}
                    />
                    {errors.email && (
                      <small className="form-text text-error">
                        {errors?.email?.message}
                      </small>
                    )}
                  </div>
                  <div className="col-md-4 col-12 mb-4">
                    <label
                      htmlFor="phone"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Customer Service Number (WA Available)</span>
                      <span className="font-bold text-muted">
                        {watchFields["phone"]?.length || 0} / 15
                      </span>
                    </label>
                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      className="form-control rounded-8px"
                      {...register("phone", {
                        required: "Please input customer service WA number",
                        pattern: {
                          value: /08[1-9]{1}[1-9]{1}[0-9]{5,11}$/,
                          message: "Invalid format i.e (0818999999)",
                        },
                        maxLength: {
                          value: 15,
                          message: "Maximum character 15",
                        },
                      })}
                    />
                    {errors.phone && (
                      <small className="form-text text-error">
                        {errors?.phone?.message}
                      </small>
                    )}
                  </div>
                  <div className="col-md-4 col-12 mb-4">
                    <label
                      htmlFor="website_url"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Website URL</span>
                      <span className="font-bold text-muted">
                        {watchFields["website_url"]?.length || 0} / 100
                      </span>
                    </label>
                    <input
                      type="text"
                      id="website_url"
                      name="website_url"
                      className="form-control rounded-8px"
                      {...register("website_url", {
                        pattern: {
                          value:
                            /(http(s)?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi,
                          message:
                            "Invalid website url, use http:// or https://",
                        },
                        maxLength: {
                          value: 100,
                          message: "Maximum character 100",
                        },
                      })}
                    />
                    {errors.website_url && (
                      <small className="form-text text-error">
                        {errors?.website_url?.message}
                      </small>
                    )}
                  </div>
                  <div className="col-md-4 col-12 mb-4">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="province"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Province</span>
                      </label>
                      <Controller
                        render={({ field }) => (
                          <SelectSearchBootstrap
                            {...field}
                            options={provinces}
                            search
                            closeOnSelect={true}
                            placeholder="Search for province"
                            onChange={(e) => handleChangeProvince(e)}
                            value={
                              watchFields["province"]
                                ? watchFields["province"]["code"]
                                : ""
                            }
                          />
                        )}
                        name="province.code"
                        control={control}
                        rules={{
                          required: "Please select province",
                        }}
                        defaultValue={
                          watchFields["province"]
                            ? watchFields["province"]["code"]
                            : ""
                        }
                      />
                      {errors?.province?.code && (
                        <small className="form-text text-error">
                          {errors?.province?.code?.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 col-12 mb-4">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="city"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>City</span>
                      </label>
                      {getDistrict?.isLoading && (
                        <SelectSearchBootstrap
                          options={districts}
                          search
                          closeOnSelect={true}
                          placeholder="Loading cities ..."
                        />
                      )}
                      {!getDistrict?.isLoading &&
                        (districts?.length > 0 ||
                          (watchFields["district"] &&
                            watchFields["district"]["code"])) && (
                          <Controller
                            render={({ field }) => (
                              <SelectSearchBootstrap
                                {...field}
                                options={districts}
                                search
                                closeOnSelect={true}
                                placeholder="Search for city"
                                onChange={(e) => handleChangeDistrict(e)}
                                value={
                                  watchFields["district"]
                                    ? watchFields["district"]["code"]
                                    : ""
                                }
                              />
                            )}
                            name="district.code"
                            control={control}
                            rules={{
                              required: "Please select city",
                            }}
                            defaultValue={
                              watchFields["district"]
                                ? watchFields["district"]["code"]
                                : ""
                            }
                          />
                        )}
                      {errors?.district?.code && (
                        <small className="form-text text-error">
                          {errors?.district?.code?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 col-12 mb-4">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="city"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Sub District</span>
                      </label>
                      {getSubDistrict?.isLoading && (
                        <SelectSearchBootstrap
                          options={districts}
                          search
                          closeOnSelect={true}
                          placeholder="Loading sub district ..."
                        />
                      )}
                      {!getSubDistrict?.isLoading &&
                        (subdistricts?.length > 0 ||
                          (watchFields["subdistrict"] &&
                            watchFields["subdistrict"]["code"])) && (
                          <Controller
                            render={({ field }) => (
                              <SelectSearchBootstrap
                                {...field}
                                options={subdistricts}
                                search
                                closeOnSelect={true}
                                placeholder="Search for sub district"
                                onChange={(e) => handleChangeSubDistrict(e)}
                                value={
                                  watchFields["subdistrict"]
                                    ? watchFields["subdistrict"]["code"]
                                    : ""
                                }
                              />
                            )}
                            name="subdistrict.code"
                            control={control}
                            rules={{
                              required: "Please select sub district",
                            }}
                            defaultValue={
                              watchFields["subdistrict"]
                                ? watchFields["subdistrict"]["code"]
                                : ""
                            }
                          />
                        )}
                      {errors?.subdistrict?.code && (
                        <small className="form-text text-error">
                          {errors?.subdistrict?.code?.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="zip_code"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Postal Code</span>
                        <span className="font-bold text-muted">
                          {watchFields["zip_code"]?.length || 0} / 6
                        </span>
                      </label>
                      <input
                        type="text"
                        id="zip_code"
                        name="zip_code"
                        className="form-control rounded-8px"
                        {...register("zip_code", {
                          required: "Please input property postal code",
                          maxLength: {
                            value: 6,
                            message: "Maximum character 6",
                          },
                        })}
                      />
                      {errors.zip_code && (
                        <small className="form-text text-error">
                          {errors?.zip_code?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="timezone"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Select Time Zone</span>
                      </label>
                      <Controller
                        name="timezone"
                        control={control}
                        render={({ field }) => (
                          <SelectSearchBootstrap
                            {...field}
                            options={optionsTimeZone}
                            search
                            closeOnSelect={true}
                            placeholder="Select timezone"
                          />
                        )}
                        rules={{
                          required: "Please select property timezone",
                        }}
                        defaultValue={watchFields["timezone"] || ""}
                      />
                      {errors.timezone && (
                        <small className="form-text text-error">
                          {errors?.timezone?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-8 col-12"></div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="about"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Detail Address</span>
                        <span className="font-bold text-muted">
                          {watchFields["address"]?.length || 0} / 200
                        </span>
                      </label>
                      <textarea
                        className="form-control rounded-8px"
                        name="address"
                        {...register("address", {
                          required: "Please input detail address",
                          maxLength: {
                            value: 200,
                            message: "Max 200 character",
                          },
                        })}
                        rows="3"
                      ></textarea>
                      {errors.address && (
                        <small className="form-text text-error">
                          {errors?.address?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group mb-4">
                      <label className="control-label font-12 font-bold">
                        Property Location
                      </label>
                      <p className="font-13 text-secondary">
                        Make sure the location you marked on the map matches the
                        address you entered above.
                      </p>
                      {(!watchFields["latitude"] ||
                        !watchFields["longitude"]) && (
                        <button
                          type="button"
                          className="btn btn-set-point"
                          onClick={() => toggle()}
                        >
                          <i className="fas fa-map-marker-alt mr-3 font-14"></i>{" "}
                          Set Location
                        </button>
                      )}
                      {watchFields["latitude"] && watchFields["longitude"] && (
                        <div
                          className={css`
                            display: block;
                            border-radius: 8px;
                            width: 100%;
                            height: 200px;
                          `}
                          id="map-preview-container"
                          onClick={() => toggle()}
                        ></div>
                      )}
                      {(errors?.latitude || errors?.longitude) && (
                        <p className="text-danger font-12 mt-1">
                          Please set property location
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h4 className="font-18">Logo &amp; Media</h4>
                  </div>
                  <div className="col-md-3 col-12">
                    <div className="form-group mb-4">
                      <label className="control-label font-12 font-bold">
                        Logo (Square)
                      </label>
                      <Controller
                        render={({ field }) => (
                          <NewImageUploader
                            {...field}
                            compID={`form_property_logo_square`}
                            maxSize={3096}
                            background="#fafafa"
                            aspectRatio={1 / 1}
                            width={300}
                            height={300}
                            ratioParams="height"
                            size="auto"
                            useCropper={true}
                            image={
                              watchFields["logo"] &&
                              watchFields["logo"]["square"]
                                ? watchFields["logo"] &&
                                  watchFields["logo"]["square"]
                                : ""
                            }
                            onUploadDone={(value) =>
                              setValue(`logo.square`, value)
                            }
                            onRemove={() => setValue(`logo.square`, "")}
                            errorNote={
                              errors && errors?.logo && errors?.logo?.square
                                ? errors?.logo?.square?.message || ""
                                : ""
                            }
                          />
                        )}
                        name={`logo.square`}
                        control={control}
                        rules={{
                          required: "Please upload logo (square)",
                        }}
                      />
                      <span className="d-block font-11 text-muted">
                        Recommendation dimensions 300 x 300 pixels. Max file
                        size 3mb.
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="form-group mb-4">
                      <label className="control-label font-12 font-bold">
                        Logo (Rectangle)
                      </label>
                      <Controller
                        render={({ field }) => (
                          <NewImageUploader
                            {...field}
                            compID={`form_property_logo_rectangle`}
                            maxSize={3096}
                            background="#fafafa"
                            aspectRatio={3 / 2}
                            width={300}
                            height={200}
                            ratioParams="height"
                            size="auto"
                            useCropper={true}
                            image={
                              watchFields["logo"] &&
                              watchFields["logo"]["rectangle"]
                                ? watchFields["logo"] &&
                                  watchFields["logo"]["rectangle"]
                                : ""
                            }
                            onUploadDone={(value) =>
                              setValue(`logo.rectangle`, value)
                            }
                            onRemove={() => setValue(`logo.rectangle`, "")}
                            errorNote={
                              errors && errors?.logo && errors?.logo?.rectangle
                                ? errors?.logo?.rectangle?.message || ""
                                : ""
                            }
                          />
                        )}
                        name={`logo.rectangle`}
                        control={control}
                        rules={{
                          required: "Please upload logo (rectangle)",
                        }}
                      />
                      <span className="d-block font-11 text-muted">
                        Recommendation dimensions 300 x 200 pixels. Max file
                        size 3mb.
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5 col-12">
                    <div className="form-group mb-4">
                      <label className="control-label font-12 font-bold">
                        Banner
                      </label>
                      <Controller
                        render={({ field }) => (
                          <NewImageUploader
                            {...field}
                            compID={`form_property_image_banner_url`}
                            maxSize={3096}
                            background="#fafafa"
                            aspectRatio={16 / 9}
                            width={1280}
                            height={720}
                            ratioParams="height"
                            size="auto"
                            useCropper={true}
                            image={
                              watchFields["image_banner_url"]
                                ? watchFields["image_banner_url"] &&
                                  watchFields["image_banner_url"]
                                : ""
                            }
                            onUploadDone={(value) =>
                              setValue(`image_banner_url`, value)
                            }
                            onRemove={() => setValue(`image_banner_url`, "")}
                            errorNote={
                              errors && errors?.image_banner_url
                                ? errors?.image_banner_url?.message || ""
                                : ""
                            }
                          />
                        )}
                        name={`image_banner_url`}
                        control={control}
                        rules={{
                          required: "Please upload property banner",
                        }}
                      />
                      <span className="d-block font-11 text-muted">
                        Recommendation dimensions 1280 x 720 pixels. Max file
                        size 3mb.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h4 className="font-18">Delivery Courier</h4>
                  </div>
                  {!getDetailProperty?.isLoading &&
                    !getDeliveryPackage?.isLoading &&
                    getDetailProperty?.isSuccess &&
                    getDeliveryPackage?.isSuccess && (
                      <div className="col-12">
                        <div
                          className="d-flex justify-content-start align-items-start flex-wrap"
                          style={{ gap: 8 }}
                        >
                          {!getDeliveryPackage.isLoading &&
                            getDeliveryPackage?.isSuccess &&
                            deliveryPackages?.length > 0 &&
                            deliveryPackages?.map((val, key) => (
                              <div className="p-3" key={val?.id}>
                                <span className="font-14 font-bold">
                                  {val?.name}
                                </span>
                                <ul className="list-group list-group-flush">
                                  {val?.delivery_packages?.length > 0 &&
                                    val?.delivery_packages?.map((item, idx) => (
                                      <li
                                        className="list-group-item"
                                        key={key + "-" + item?.id}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={
                                                watchFields[
                                                  `property_deliveries`
                                                ] &&
                                                watchFields[
                                                  `property_deliveries`
                                                ].length > 0 &&
                                                watchFields[
                                                  `property_deliveries`
                                                ][key + idx] &&
                                                watchFields[
                                                  `property_deliveries`
                                                ][key + idx]["checked_st"] ===
                                                  true
                                              }
                                              onChange={(e) =>
                                                handleChangeDelivery(item?.id, {
                                                  target: {
                                                    name: e.target.name,
                                                    value: e.target.checked,
                                                  },
                                                })
                                              }
                                              name={`property_deliveries.${
                                                key + idx
                                              }`}
                                              color="primary"
                                              control={control}
                                            />
                                          }
                                          label={item?.name}
                                        />
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  {(getDetailProperty?.isLoading ||
                    getDeliveryPackage?.isLoading) && (
                    <div className="col-12">
                      <p className="font-14 font-bold text-center">
                        Get Delivery Package ...
                      </p>
                    </div>
                  )}

                  <div className="col-12">
                    <div className="form-group text-center">
                      <button
                        type="button"
                        className={cx(
                          css`
                            padding: 14px 64px;
                          `,
                          "btn btn-md btn-default border-0 font-12 font-bold rounded-8px mr-2"
                        )}
                        onClick={() => {
                          History.push("/property");
                        }}
                      >
                        CANCEL
                      </button>
                      <button
                        type="submit"
                        className={cx(
                          css`
                            background-color: #bbdefb !important;
                            color: #2196f3 !important;
                            padding: 14px 64px;
                          `,
                          "btn btn-md border-0 font-12 font-bold rounded-8px"
                        )}
                        disabled={
                          mutationUpdateProperty?.isLoading ||
                          mutationMappingDelivery?.isLoading
                        }
                      >
                        SAVE
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        backdrop={false}
        centered={true}
        size="xl"
        zIndex={1300}
        modalClassName={css`
          max-height: 100%;
          overflow-y: scroll !important;
          background: rgba(0, 0, 0, 0.7);
        `}
        className={cx(mapModal, "modal-dialog modal-dialog-scrollable")}
      >
        <ModalHeader toggle={toggle}>SELECT LOCATION</ModalHeader>
        <ModalBody>
          <div
            className={css`
              width: 100%;
              position: absolute;
              top: 12px;
              z-index: 9;
              display: flex;
              flex-direction: column;
              justity-content: flex-start;
              align-items: center;
            `}
          >
            <input
              type="text"
              className={css`
                width: 95%;
                height: 50px;
                background-color: #ffffff;
                border-radius: 25px;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
                border: none;
                padding: 20px;

                &::placeholder {
                  color: #757575;
                  font-size: 11px;
                }

                &:focus,
                &:active,
                &:hover {
                  outline: none;
                }
              `}
              placeholder="Cari alamat"
              onChange={(e) => handleChangeSearchAddress(e)}
              value={searchAddress}
            />
            <div
              className={cx(
                css`
                  width: 90%;
                  padding: 8px;
                  background-color: #ffffff;
                  border-radius: 25px;
                  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
                  border: none;
                  margin-top: 10px;
                `,
                "d-none"
              )}
              ref={boxPlacePredictionsRef}
            >
              {listPlaces?.length > 0 && searchAddress !== "" && (
                <ul className="list-group list-group-flush">
                  {listPlaces?.map((place, index) => {
                    return (
                      <li
                        className="list-group-item"
                        onClick={() => handleGetDetailPlace(place?.place_id)}
                        key={index}
                      >
                        <span className="font-14 font-bold d-block">
                          {place?.structured_formatting?.main_text || "-"}
                        </span>
                        <span className="font-12 d-block">
                          {place?.structured_formatting?.secondary_text || ""}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
          <div
            className={css`
              width: 100%;
              height: calc(100% - 74px);
            `}
            id="map-container"
          ></div>
        </ModalBody>
        <ModalFooter>
          {locationAddress !== "" && (
            <p className="font-11">{locationAddress || ""}</p>
          )}
          <button
            type="button"
            className={cx(
              css`
                padding: 0px 18px;
                background-color: #ff9800;
                border-radius: 25px;
                color: #212121;
                height: 50px;
              `,
              "btn btn-block font-bold font-16"
            )}
            onClick={() => toggle()}
          >
            SET LOCATION
          </button>
        </ModalFooter>
      </Modal>
    </BaseLayout>
  );
};

export default FormPropertyEdit;
